import { render } from "./wishlistPage.vue?vue&type=template&id=d0ce664e"
import script from "./wishlistPage.vue?vue&type=script&lang=js"
export * from "./wishlistPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__